import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { displayToast } from 'bundles/connect/helpers/display_toast';
import { deleteRequest } from 'helpers/turbo_api';
import React, { useState } from 'react';
import { Button } from 'components/ui/button';
import { Modal } from 'react-bootstrap-5';

type Props = {
  callListName: string;
  pathForCallList: string;
  show: boolean;
  onHide: () => void;
}

export default function CallListDeleteModal({ callListName, show, onHide, pathForCallList }: Props) {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    await deleteRequest(pathForCallList)
      .then(() => {
        displayToast('List successfully deleted', 'success');
      })
      .catch(() => displayToast('Something went wrong', 'error'))
      .finally(() => {
        setDeleting(false);
        onHide();
      });
  };

  return (
    <Modal centered show={show} onHide={onHide}>
      <Modal.Header className="flex-row" closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete the call list <strong>{callListName}</strong>?
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button disabled={deleting} label="Cancel" variant="ghost" onClick={onHide} />
        <Button disabled={deleting} icon={faTrash} label="Delete" variant="destructive" onClick={handleDelete} />
      </Modal.Footer>
    </Modal>
  );
}
